export default "__VITE_ASSET__DgC1vgo4__"